export default "__VITE_ASSET__BUr3fLAR__"